<template>
  <div class="sidebar-expand mt-3 pt-3 px-4 d-lg-none">
    <div class="row border border-info rounded py-2">
      <div class="col-6">
        <LanguangeSwitcher />
      </div>
      <div class="col-6">
        <Logout />
      </div>
    </div>
    <ul class="pt-3 px-4">
      <span
        v-for="(item, i) of menus"
        :key="i"
      >
        <router-link
          v-if="item.link && permissions.includes(item.permission)"
          tag="li"
          :to="item.link"
        >
          <div class="d-flex align-items-center m-0 py-2 mb-2">
            <span class="px-md-3 px-lg-3">
              <i
                class="fa fa-fw"
                :class="item.icon"
                aria-hidden="true"
              />
            </span>
            <small class="font-weight-bold item-text text-truncate">
              {{ item.name }}
            </small>
          </div>
        </router-link>

        <div
          v-if="item.children && showParent(item)"
          @click="expand(i)"
        >
          <div class="d-flex m-0 py-2 mb-2 justify-content-center">
            <span class="px-md-3 px-lg-3">
              <i
                class="fa fa-fw"
                :class="item.icon"
                aria-hidden="true"
              />
            </span>
            <small class="font-weight-bold sidebar-text text-truncate">
              {{ item.name }}
            </small>
            <i
              class="fa ml-auto"
              :class="{
                'fa-angle-up': item.expanded,
                'fa-angle-down': !item.expanded
              }"
            />
          </div>

          <div v-if="item.expanded">
            <span
              v-for="(child, c) of item.children"
              :key="c"
            >
              <router-link
                v-if="permissions.includes(child.permission)"
                :to="child.link"
                tag="div"
                class="pl-5 py-2"
              >
                <small>
                  <small class="font-weight-bold pl-1">
                    {{ child.name }}
                  </small>
                </small>
              </router-link>
            </span>
          </div>
        </div>
      </span>
    </ul>
  </div>
</template>

<script>
import LanguangeSwitcher from '@/components/LanguangeSwitcher2'
import Logout from '@/components/Logout'

export default {
  components: {
    LanguangeSwitcher,
    Logout
  },

  data () {
    return {
      menus: [
        {
          link: 'fdm-dashboard',
          name: 'Dashboard',
          icon: 'fa-pie-chart',
          permission: 'dashboard'
        },
        // {
        //   link: 'dashboard',
        //   name: 'Dashboard',
        //   icon: 'fa-pie-chart',
        //   permission: 'dashboard'
        // },
        {
          link: 'my-assessment',
          name: 'My FDM',
          icon: 'fa-file-text-o',
          permission: 'my_dhm'
        },
        {
          link: 'all-assessment',
          name: 'All FDM',
          icon: 'fa-files-o',
          permission: 'all_dhm'
        },
        {
          link: 'user-management',
          name: 'User Management',
          icon: 'fa-user',
          permission: 'user'
        },
        {
          name: 'Settings',
          icon: 'fa-cog',
          expanded: true,
          children: [
            {
              link: 'manage-security-group',
              name: 'Manage Security Group',
              permission: 'role'
            },
            {
              link: 'manage-master-data',
              name: 'Manage Master Data',
              permission: 'master_data'
            },
            {
              link: 'manage-notification',
              name: 'Manage Notification',
              permission: 'notification'
            },
            {
              link: 'manage-question',
              name: 'Manage Question',
              permission: 'question'
            }
          ]
        }
      ],
      permissions: []
    }
  },

  mounted () {
    const dataLoc = JSON.parse(localStorage.getItem('profile'))
    this.permissions = dataLoc.role.permissions
      .filter(permission => permission.permissions.includes('browse'))
      .map(({ category }) => category)
  },

  methods: {
    expand (index) {
      this.menus[index].expanded = !this.menus[index].expanded
    },
    showParent (item) {
      return item.children.some(child => this.permissions.includes(child.permission))
    }
  }
}
</script>

<style scoped>
ul li {
  list-style: none;
  text-decoration: none;
  cursor: pointer;
}
a {
  text-decoration: none;
  color: black;
}
.router-link-active {
  background-color: #18b2bd;
  color: white !important;
  border-radius: 4px;
  cursor: pointer;
}
.sidebar-text {
  padding-top: 3px;
}
.sidebar-expand {
  background-color: #ffffff;
  min-width: 85vw;
  border-radius: 12px;
  border: 1px solid #dedede;
}
</style>
